/**
 * Created by JIocb on 19.06.2017.
 */

namespace Factive.Game {
    import Signal = Factive.Core.Signal.Signal;
    import DependenciesContainer = Factive.Core.DependenciesContainer;
    import DisplayObject = PIXI.DisplayObject;

    export class IntroScreen extends PIXI.Container {
        public signal: Signal;
        private _dc: DependenciesContainer;
        private _playButton: DragonBonesButton;
        private _sceneArmature: dragonBones.Armature;
        private _loadingText: PIXI.Text;
        private _progress: number = 0;

        constructor(dc) {
            super();
            this._dc = dc;
        }
        public build()
        {
            // var embed = this._dc.get("IntroScreenEmbed");

            // var atlastexture = PIXI.Sprite.fromImage(embed.textureAtlas).texture;

            /*dragonBones.PixiFactory.factory.parseTextureAtlasData(embed.textureJson, atlastexture);
            dragonBones.PixiFactory.factory.parseDragonBonesData(embed.skeletonJson);*/
            this.signal = new Signal();

            this._sceneArmature = dragonBones.PixiFactory.factory.buildArmature("IntroScreen");
            this.addChild(this._sceneArmature.display as DisplayObject);
            dragonBones.WorldClock.clock.add(this._sceneArmature);
            //dragonBones.WorldClock.clock.add(sceneArmature.getSlot("Logo").childArmature);

            this._sceneArmature.getSlot("Logo").childArmature.animation.play("appear",1);
            //this._sceneArmature.getSlot("FallenCubes").childArmature.animation.gotoAndStopByFrame('fall',0);

            this._sceneArmature.getSlot("BtnPlay").childArmature.animation.gotoAndStopByFrame('appear',0);

            this._sceneArmature.getSlot("BtnPlay").childArmature.display.visible = false;

            this._loadingText = new PIXI.Text("0%", <PIXI.TextStyle>{
                fontFamily: 'Medium',
                fontSize: 28*this._dc.get("AssetScale"),
                fill: '#FFFFFF',
                align:"center"
            });
            this._loadingText.x = 0 * this._dc.get("AssetScale");
            this._loadingText.y = 190 * this._dc.get("AssetScale");
            this._loadingText.anchor.set(.5,.5);

            this._sceneArmature.display.addChild(this._loadingText);

            //this.checkSound();
        }

        // private checkSound():void
        // {
        //     let sm:SoundManager = <SoundManager>this._dc.get("SoundManager");
        //     let ls:StorageManager = <StorageManager>this._dc.get("StorageManager");
        //     let mute:boolean = ls.loadData(StorageManagerConstants.MUTE_SOUNDS) == "1";
        //
        //     if(!mute)
        //     {
        //         ls.saveData(StorageManagerConstants.MUTE_SOUNDS, "1");
        //         sm.mute(true);
        //     }
        //     else
        //     {
        //         sm.mute(mute);
        //     }
        // }

        private _box: DiceRendererClass;
        private sprite_3D: Factive.Game.Pixi3DSprite;

        public startInteract():void
        {
            this._playButton = new DragonBonesButton(this._sceneArmature.getSlot("BtnPlay").childArmature,this._dc);
            this._playButton.addPressListener(this.handlePressPlay,this);
            this._playButton.enableInput(false);
            this._playButton.addLabel(this._dc.get("LocalizationManager").getText("play"),0,0,<PIXI.TextStyle>{
                fontFamily: 'Medium',
                fontSize: 28*this._dc.get("AssetScale"),
                fill: '#FFFFFF',
                align:"center"
            });

            this._loadingText.visible = false;
            
            this._sceneArmature.getSlot("BtnPlay").childArmature.display.visible = true;
            this._sceneArmature.getSlot("BtnPlay").childArmature.animation.play("appear",1);
            this._playButton.enableInput(true);

            this._box = this._dc.get("DiceRenderer");
            this.sprite_3D = new Pixi3DSprite(this._box, this._dc.get("AssetScale"));
            //this.sprite_3D.visible = false;
            //this._sceneArmature.display.addChild(this.sprite_3D);
            this._box.startRegularThrow2();
        }

        private handlePressPlay():void
        {
            this._box.hideDices();
            this.signal.dispatch("play");
        }

        public destroy():void
        {
            this.signal.removeAll();
            this.signal = null;

            this._dc = null;

            this._playButton.removePressListener(this.handlePressPlay,this);
            this._playButton.destroy();
            this._playButton = null;

            this.removeChildren();
        }

        IncLoadIndex() {
            this._progress++;
            this._loadingText.text = Math.floor(this._progress / 5 * 100) + "%"
        }
    }
}


// WEBPACK FOOTER //
// src/typescript/Game/Engine/View/IntroScreen.ts